import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconDropdown(props: IconProps) {
  return (
    <BaseIcon {...props} viewBox="0 0 48 48">
      <path
        d="M22.4273 31.3517C23.254 32.2161 24.746 32.2161 25.5727 31.3517L33.4973 23.0649C34.649 21.8605 33.6943 20 31.9246 20H16.0754C14.3057 20 13.351 21.8605 14.5027 23.0649L22.4273 31.3517Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
